


















import { isNumber } from "lodash";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Card, { NextCardDirection } from "./Card.vue";
import Control from "./Control.vue";

@Component({ components: { Card, Control } })
export default class CellSizeCard extends Vue {
  @Prop({ required: true })
  private nextCardDirection: NextCardDirection;

  @Prop({ required: true })
  private pointerAnimationDuration: number;

  @Prop({ required: true })
  private cellSize: number;

  private get minCellSize() {
    return 45;
  }

  private get maxCellSize() {
    return 55;
  }

  private isValidCellSize(cellSize: number) {
    return isNumber(cellSize)
      && cellSize >= this.minCellSize
      && cellSize <= this.maxCellSize;
  }
}
